var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-field',{attrs:{"id":"zip-code-field","validation":_vm.$v,"validationMessage":_vm.textRequired,"label":_vm.textLabel,"rest":{
    placeholder: _vm.placeholder
      ? _vm.textLabel
      : null,
    autocomplete: 'postal-code',
    name: 'postal-code',
  },"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},on:{"input":_vm.input,"blur":_vm.blur},model:{value:(_vm.form[_vm.name]),callback:function ($$v) {_vm.$set(_vm.form, _vm.name, $$v)},expression:"form[name]"}})}
var staticRenderFns = []

export { render, staticRenderFns }